// material-ui
import AddIcon from '@mui/icons-material/Add'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import {
  Badge,
  Box,
  CardActions,
  List,
  ListItemButton,
  Pagination,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { useParams } from 'react-router-dom'

import WatchLaterTwoToneIcon from '@mui/icons-material/WatchLaterTwoTone'
import { Avatar, Button, Divider, Grid, Stack, Typography } from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickAlert from 'components/RedQuickAlert'
import RedQuickInputTags from 'components/RedQuickInputTags'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import { gridSpacing } from 'store/constant'
import TitleService, { GetTimeSince } from 'title-service'
import SecondaryAction from 'ui-component/cards/CardSecondaryAction'
import SubCard from 'ui-component/cards/SubCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { ApprovalRequestStatus, MediaStatus } from 'features/enumerations'

// assets
import Busy from 'components/Busy'
import MediaDescriptionForm from 'components/MediaDescriptionForm'
import MediaForm from 'components/MediaForm'
import TagAdditionComponent from 'components/TagAdditionComponent'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_approvalRequest } from 'features/approvalRequest/approvalRequest-slice'
import * as autoThunks from 'features/auto-thunks'
import { get_all_media, is_media_busy } from 'features/media/media-slice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let media_list = useSelector(get_all_media)
  let media_busy = useSelector(is_media_busy)
  let approvalRequest_list = useSelector(get_all_approvalRequest)
  const [mediaPage, setMediaPage] = React.useState(null)
  const [mediaDuration, setMediaDuration] = React.useState(null)
  const [mediaLocation, setMediaLocation] = React.useState(null)
  const [mediaPreviewDuration, setMediaPreviewDuration] = React.useState(null)
  const [mediaPreviewLocation, setMediaPreviewLocation] = React.useState(null)
  const [thumbnailLocation, setThumbnailLocation] = React.useState(null)
  const [transparentTitleLocation, setTransparentTitleLocation] =
    React.useState(null)
  const [newMedia, setNewMedia] = React.useState(null)
  const [newMediaValid, setNewMediaValid] = React.useState(null)
  const [newMediaDirty, setNewMediaDirty] = React.useState(null)
  const [newMediaTags, setNewMediaTags] = React.useState(null)
  const [uploaded, setUploaded] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [thumbnails, setThumbnails] = React.useState(null)
  const [thumbnailsDirty, setThumbnailsDirty] = React.useState(null)
  const [mode, setMode] = React.useState(null)
  const [mediaResourceRandom, setMediaResourceRandom] = React.useState(null)
  const [mediaFilter, setMediaFilter] = React.useState(null)
  const [newMediaDescription, setNewMediaDescription] = React.useState(null)
  const [newMediaDescriptionValid, setNewMediaDescriptionValid] =
    React.useState(null)
  const [newMediaDescriptionDirty, setNewMediaDescriptionDirty] =
    React.useState(null)
  const [progressContext, setProgressContext] = React.useState(null)
  const [newMediaContext, setNewMediaContext] = React.useState(null)
  const [all_progress, setAll_progress] = React.useState(null)
  const [isUploading, setIsUploading] = React.useState(null)
  const [newThumbnailsContext, setNewThumbnailsContext] = React.useState(null)
  const [localMedias, setLocalMedias] = React.useState(null)
  const [selectedMedia, setSelectedMedia] = React.useState(null)
  const [tags, setTags] = React.useState(null)
  const [tagsDirty, setTagsDirty] = React.useState(null)
  const [selectedMediaItem, setSelectedMediaItem] = React.useState(null)
  const [mediaDescription, setMediaDescription] = React.useState(null)
  const [mediaDescriptionDirty, setMediaDescriptionDirty] = React.useState(null)
  const [mediaDescriptionValid, setMediaDescriptionValid] = React.useState(null)
  const [selectedThumbnail, setSelectedThumbnail] = React.useState(null)
  const [refreshToken, setRefreshToken] = React.useState(null)
  const [mediaContext, setMediaContext] = React.useState(null)
  const [thumbnailsContext, setThumbnailsContext] = React.useState(null)
  const [deleteArgs, setDeleteArgs] = React.useState(null)
  const [newMediaUpdate, setNewMediaUpdate] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.load_content_house_medias({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [
    claims?.user,
    params?.id,
    contextId,
    progressContext,
    newMediaContext,
    mediaContext,
  ])
  useEffect(() => {
    if (params?.id) {
      function setup_media_context() {
        let contextId = uuid()
        setProgressContext(contextId)
        setContextId(uuid())
        // Using the contenthouse id requires a new claim for the user.
        setNewMediaContext({
          title: 'Upload Video',
          componentTitle: 'Upload Video',
          accept: 'video/mp4,video/x-m4v,video/*',
          uploadOnce: true,
          limit: 1,
          video: true,
          aspectRatio: 16 / 9,
          description: 'Upload your new video',
          contextId: contextId,
          storageLocation: `media/${params?.id}/media_mediaRel`,
        })
      }
      setup_media_context()
    }
  }, [params?.id])
  useEffect(() => {
    if (all_progress) {
      function setup_progress() {
        if (progressContext) {
          let progress = all_progress.find((v) => v.id === progressContext)
          if (progress) {
            if (progress.value === 1) {
              setIsUploading(false)
            } else {
              setIsUploading(true)
            }
          }
        }
      }
      setup_progress()
    }
  }, [all_progress])
  useEffect(() => {
    if (params?.id) {
      function setup_thumbnail_context() {
        let contextId = uuid()
        // Using the contenthouse id requires a new claim for the user.
        setNewThumbnailsContext({
          title: 'Thumbnails',
          componentTitle: 'Thumbnails',
          accept: 'image/*',
          uploadOnce: false,
          limit: 5,
          aspectRatio: 16 / 9,
          maxSize: 400,
          description: 'Upload thumbnails for your video',
          contextId: contextId,
          storageLocation: `media/${params?.id}/thumbnails`,
        })
      }
      setup_thumbnail_context()
    }
  }, [params?.id, mediaResourceRandom])
  useEffect(() => {
    if (claims?.user && params?.id) {
      function setup_local_medias() {
        // Using the contenthouse id requires a new claim for the user.
        setLocalMedias(media_list.filter((x) => x.owner === params.id))
      }
      setup_local_medias()
    }
  }, [
    refreshToken,
    claims?.user,
    params?.id,
    media_list.length,
    contextId,
    progressContext,
    newMediaContext,
  ])
  useEffect(() => {
    function setup() {
      if (!mode) {
        setMode('add-new-media')
      }
    }
    setup()
  })
  useEffect(() => {
    function on_set_selected_media() {
      let item = (localMedias || []).find((v) => v.id === selectedMedia)
      setSelectedMediaItem(item)
      if (item) {
        setMediaDescription(item.description || {})
        setTags((item.tag || []).map((v) => v.name).filter((x) => x))
        setThumbnails(
          (item.thumbnails || []).map((v) => v.mediaRel).filter((x) => x),
        )
      }
    }
    on_set_selected_media()
  }, [selectedMedia, refreshToken, media_list])
  useEffect(() => {
    if (params?.id) {
      function setup_media_context() {
        let contextId = uuid()
        setProgressContext(contextId)
        setContextId(uuid())
        // Using the contenthouse id requires a new claim for the user.
        setMediaContext({
          title: 'Video',
          componentTitle: 'Video',
          accept: 'video/mp4,video/x-m4v,video/*',
          uploadOnce: true,
          limit: 0,
          video: true,
          aspectRatio: 16 / 9,
          description: 'Video',
          contextId: contextId,
          storageLocation: `media/${params?.id}/media_mediaRel`,
        })
      }
      setup_media_context()
    }
  }, [params?.id])
  useEffect(() => {
    if (params?.id) {
      function setup_thumbnail_context() {
        let contextId = uuid()
        // Using the contenthouse id requires a new claim for the user.
        setThumbnailsContext({
          title: 'Upload Thumbnails',
          componentTitle: 'Upload Thumbnails',
          accept: 'image/*',
          uploadOnce: false,
          limit: 5,
          aspectRatio: 16 / 9,
          maxSize: 400,
          description: 'Upload thumbnails for your video',
          contextId: contextId,
          storageLocation: `media/${params?.id}/thumbnails`,
        })
      }
      setup_thumbnail_context()
    }
  }, [params?.id])
  useEffect(() => {
    if (claims?.user && params?.id && selectedMedia) {
      dispatch(
        autoThunks.load_media_approval_request({
          fire_user: claims?.user,
          contentHouseId: params?.id,
          mediaId: (() => {
            function get_media_id(): any {
              return selectedMedia
            }
            return get_media_id()
          })(),
        }),
      )
    }
  }, [claims?.user, params?.id, selectedMedia])
  useEffect(() => {
    if (claims?.user && claims?.user) {
      dispatch(
        autoThunks.delete_media_from_content_house({
          userId: claims?.user,
          contentHouseId: params?.id,
          mediaId: (() => {
            function _delet(): any {
              return deleteArgs
            }
            return _delet()
          })(),
        }),
      )
    }
  }, [claims?.user, deleteArgs])
  useEffect(() => {
    if (newMediaUpdate) {
      function updateNewMediaUpdate(): any {
        setNewMedia({ ...(newMedia || {}), ...(newMediaUpdate || {}) })
      }
      updateNewMediaUpdate()
    }
  }, [newMediaUpdate])

  function clearForm() {
    setSelectedMedia(null)
    setThumbnailsDirty(false)
    setMediaDescriptionDirty(false)
    setTagsDirty(false)
    setMediaDescriptionValid(null)
    setRefreshToken(uuid())
    let contextId = uuid()
    setProgressContext(contextId)
    setContextId(uuid())
  }

  function getSelectedItem() {
    let item = media_list.find(
      (x) => x.owner === params.id && x.id === selectedMedia,
    )

    return item
  }

  function getApprovalRequestItem(): any {
    let item = approvalRequest_list.find((x) => x?.media?.id === selectedMedia)

    return item
  }

  function isApprovalRequestRejected(): any {
    let item =
      getApprovalRequestItem()?.status === ApprovalRequestStatus.Rejected

    return item
  }

  function isMediaApprovalRequestRejected(media: any): any {
    let item = approvalRequest_list.find((x) => x?.media?.id === media?.id)

    return item?.status === MediaStatus.Rejected
  }

  function mediaList(): any {
    return (function () {
      let pageSize = 30
      let list = (localMedias || [])
        .filter((x) => !x.deleted)
        .filter((mediaItem) => {
          if (mediaFilter) {
            let temp = `${mediaFilter}`
            return (
              `${mediaItem?.description?.nameDefault} ${mediaItem?.description?.descriptionDefault}`
                .toLowerCase()
                .indexOf(temp) !== -1
            )
          }
          return true
        })
      let temp_list: any[] = []
      let start = pageSize * parseFloat(mediaPage || 0)
      let end = pageSize * parseFloat((mediaPage || 0) + 1)
      for (let i = start; i < end; i++) {
        if (list[i]) {
          temp_list.push(list[i])
        }
      }
      return (
        <>
          <rq.RedQuickTextField
            title={TitleService('Filter')}
            value={mediaFilter || ''}
            onChange={(val) => {
              setMediaFilter(val)
            }}
          />
          <List
            sx={{
              maxHeight: `calc(100vh - 400px)`,
              overflowY: 'auto',
            }}
            component="nav"
            aria-label="main mailbox folders"
          >
            {temp_list.map((mediaItem, index) => {
              let statusColor = theme.palette.grey[500]
              let statusTitle = ''
              let isApproved = false
              if (mediaItem?.mediaInformation) {
                if (mediaItem?.mediaStatus === MediaStatus.Unreviewed) {
                  statusColor = theme.palette.info.main
                  statusTitle = TitleService('Unreviewed')
                } else if (mediaItem?.mediaStatus === MediaStatus.Reviewed) {
                  statusColor = theme.palette.success.main
                  statusTitle = TitleService('Reviewed')
                }
                isApproved = mediaItem.mediaStatus === MediaStatus.Approved
              }
              return (
                <ListItemButton
                  key={index}
                  selected={selectedMedia === mediaItem?.id}
                  onClick={() => {
                    setSelectedMedia(mediaItem.id)
                    setMode('view-media')
                    setRefreshToken(uuid())
                  }}
                >
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item>
                        {' '}
                        <Box sx={{ position: 'relative' }}>
                          <Badge
                            overlap="circular"
                            badgeContent={
                              <FiberManualRecordIcon
                                sx={{
                                  color: statusColor,
                                  fontSize: '0.875rem',
                                }}
                              />
                            }
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                          >
                            <Avatar
                              alt={mediaItem.name}
                              title={statusTitle}
                              src={mediaItem?.thumbnail}
                            />
                          </Badge>
                        </Box>
                      </Grid>
                      <Grid item xs zeroMinWidth>
                        <Typography
                          align="left"
                          component="div"
                          variant="subtitle1"
                        >
                          {mediaItem?.description?.nameDefault}
                        </Typography>
                        <Typography
                          align="left"
                          component="div"
                          style={{
                            whiteSpace: 'nowrap',
                            maxWidth: 200,
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          }}
                          variant="subtitle2"
                        >
                          {mediaItem?.description?.descriptionDefault}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        justifyContent="flex-end"
                        alignContent="flex-end"
                        justifyItems="flex-end"
                        alignItems="flex-end"
                      >
                        <Stack
                          direction="column"
                          justifyContent="flex-end"
                          alignContent="flex-end"
                          justifyItems="flex-end"
                          alignItems="flex-end"
                        >
                          {isApproved && SC.approveCheckSmall()}
                          {isMediaApprovalRequestRejected(mediaItem) &&
                            SC.errorSignSmall()}
                          {!isMediaApprovalRequestRejected(mediaItem) && (
                            <Typography align="left" variant="caption">
                              <WatchLaterTwoToneIcon
                                sx={{
                                  fontSize: '0.875rem',
                                  marginRight: 0.2,
                                  verticalAlign: 'sub',
                                }}
                              />
                              {GetTimeSince(mediaItem)}
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItemButton>
              )
            })}
          </List>
          <Grid item xs={12}>
            <Pagination
              onChange={(evt, value) => {
                setMediaPage(parseFloat(value) - 1)
              }}
              count={Math.ceil(list.length / pageSize)}
              color="primary"
            />
          </Grid>
        </>
      )
    })()
  }

  let output_mediaList = mediaList()

  function addNewMediaForms(addMediaToContentHouse: any): any {
    return (
      <>
        {mode === 'add-new-media' && (
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12} sm={12} md={12}>
              <MediaDescriptionForm
                page={undefined}
                form={newMediaDescription}
                onUpdate={(update, valid, dirty) => {
                  setNewMediaDescription(update)
                  setNewMediaDescriptionValid(valid)
                  setNewMediaDescriptionDirty(dirty)
                }}
                context={{
                  mediaRel: newMediaContext,
                  id: `${contextId}-media-rel`,
                }}
              />
              {true ? null : (
                <RedQuickInputTags
                  value={newMediaTags || []}
                  onUpdate={(data) => {
                    setNewMediaTags(data)
                  }}
                />
              )}
              {true ? null : (
                <TagAdditionComponent
                  onSelect={(val: string) => {
                    if (tags.indexOf(val) === -1) {
                      setTags([...tags, val])
                      setTagsDirty(true)
                    }
                  }}
                />
              )}
              <MediaForm
                page={undefined}
                form={newMedia}
                context={{
                  mediaRel: {
                    ...newMediaContext,
                    onDuration: (duration: number) => {
                      setMediaDuration(duration)
                    },
                    onStorageLocation: (location: string) => {
                      setMediaLocation(location)
                      setUploaded(true)
                    },
                  },
                  mediaPreviewUrl: {
                    title: 'Preview Media',
                    componentTitle: 'Preview Media',
                    accept: 'video/mp4,video/x-m4v,video/*',
                    uploadOnce: false,
                    limit: 1,
                    description: 'Upload your media intro clip.',
                    contextId: `${contextId}-preview`,
                    storageLocation: `media/${params?.id}/previewMedia`,
                    video: true,
                    onDuration: (duration: number) => {
                      setMediaPreviewDuration(duration)
                    },
                    onStorageLocation: (location: string) => {
                      setMediaPreviewLocation(location)
                      setUploaded(true)
                    },
                  },
                  thumbnail: {
                    image: true,
                    title: 'Media Thumbnail',
                    componentTitle: 'Media Thumbnail',
                    contextId: `${contextId}-thumbnail`,
                    aspectRatio: 16 / 9,
                    limit: 1,
                    storageLocation: `media/${params?.id}/thumbnails`,
                    description: 'Upload thumbnail title image for media',
                    maxSize: 4000,
                    onStorageLocation: (location: string) => {
                      setThumbnailLocation(location)
                      setUploaded(true)
                    },
                  },
                  transparentTitleUrl: {
                    image: true,
                    title: 'Media Transparent Title Image',
                    componentTitle: 'Media Transparent Title Image',
                    contextId: `${contextId}-transparenttitle`,
                    aspectRatio: 16 / 9,
                    limit: 1,
                    description: 'Upload cover title image for media',
                    storageLocation: `media/${params?.id}/transparentTitleImage`,
                    maxSize: 4000,
                    onStorageLocation: (location: string) => {
                      setTransparentTitleLocation(location)
                      setUploaded(true)
                    },
                  },
                  id: contextId,
                }}
                onUpdate={(update, valid, dirty) => {
                  setNewMediaUpdate({ ...update })
                  setNewMediaValid(valid)
                  setNewMediaDirty(dirty)
                }}
              />
            </Grid>

            {newMediaValid &&
              newMediaDescriptionValid &&
              !isUploading &&
              (newMediaDirty || newMediaDescriptionDirty) && (
                <Grid item xs={12}>
                  <Stack direction="row" justifyContent="flex-end">
                    <AnimateButton>
                      <Button
                        variant="contained"
                        disabled={
                          !(
                            newMediaValid &&
                            newMediaDescriptionValid &&
                            !isUploading &&
                            (newMediaDirty || newMediaDescriptionDirty)
                          )
                        }
                        onClick={async () => {
                          await dispatch(addMediaToContentHouse)
                          setNewMedia({})
                          setTransparentTitleLocation(null)
                          setThumbnailLocation(null)
                          setMediaPreviewLocation(null)
                          setMediaLocation(null)
                          setUploaded(false)
                          setNewMediaDirty(false)
                          setNewMediaDescriptionDirty(false)
                          setNewMediaDescriptionValid(false)
                          setNewMediaValid(false)
                          setNewMediaContext({
                            ...newMediaContext,
                            storageLocation: `media/${params?.id}/media_mediaRel/${uuid()}`,
                          })
                          setThumbnails([])
                          setNewMediaTags([])
                          setNewMediaDescription({})
                          let contextId = uuid()
                          setProgressContext(contextId)
                          setContextId(uuid())
                          clearForm()
                        }}
                      >
                        {TitleService('Verify & Submit')}
                      </Button>
                    </AnimateButton>
                  </Stack>
                </Grid>
              )}
          </Grid>
        )}
      </>
    )
  }

  let output_addNewMediaForms = addNewMediaForms(
    autoThunks.addNewMediaContentToContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      media: (() => {
        function _getNewMedia(): any {
          let updates: any = {}
          if (mediaDuration) {
            updates.mediaDuration = mediaDuration
          }
          if (mediaPreviewDuration) {
            updates.mediaPreviewDuration = mediaPreviewDuration
          }
          if (mediaLocation) {
            updates.mediaRelLocation = mediaLocation
          }
          if (mediaPreviewLocation) {
            updates.mediaPreviewLocation = mediaPreviewLocation
          }
          if (thumbnailLocation) {
            updates.thumbnailLocation = thumbnailLocation
          }
          if (transparentTitleLocation) {
            updates.transparentTitleLocation = transparentTitleLocation
          }
          return {
            ...(newMedia || {}),
            ...updates,
          }
        }
        return _getNewMedia()
      })(),
      tags: (() => {
        function _getNewMedia(): any {
          return newMediaTags
        }
        return _getNewMedia()
      })(),
      mediaDescription: (() => {
        function _getNewMediaDescription(): any {
          return newMediaDescription
        }
        return _getNewMediaDescription()
      })(),
      thumbNails: (() => {
        function _getThumbnails(): any {
          return thumbnails
        }
        return _getThumbnails()
      })(),
    }),
  )

  function updateMediaForms(
    updateMediaToContentHouse: any,
    requestMediaApproval: any,
    cancelMediaApproval: any,
  ): any {
    return (
      <>
        {mode === 'view-media' && selectedMediaItem && (
          <>
            <CardActions>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
              >
                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-end"
                    spacing={2}
                  >
                    {/**
                     * wrong prop color="error"
                     * color?: "inherit" | "primary" | "secondary" | undefined
                     * placeholder style={{color: 'red', borderColor: '#EDE7F6'}}
                     */}
                    {getSelectedItem()?.mediaStatus ===
                      MediaStatus.Unreviewed && (
                      <Grid item>
                        <Button
                          variant="contained"
                          disabled={media_busy}
                          onClick={async () => {
                            await dispatch(requestMediaApproval)
                          }}
                        >
                          {TitleService('Request Approval')}
                        </Button>
                      </Grid>
                    )}
                    {getSelectedItem()?.mediaStatus ===
                      MediaStatus.Rejected && (
                      <Grid item>
                        <Button
                          variant="contained"
                          disabled={media_busy}
                          onClick={async () => {
                            await dispatch(requestMediaApproval)
                          }}
                        >
                          {TitleService('Re-Request Approval')}
                        </Button>
                      </Grid>
                    )}
                    {getSelectedItem()?.mediaStatus ===
                      MediaStatus.RequestingApproval && (
                      <Grid item>
                        <Button
                          variant="outline"
                          disabled={media_busy}
                          onClick={async () => {
                            await dispatch(cancelMediaApproval)
                          }}
                        >
                          {TitleService('Cancel Request')}
                        </Button>
                      </Grid>
                    )}
                    {getSelectedItem()?.id && (
                      <Grid item>
                        <RedQuickAlert
                          button={
                            <Button
                              disabled={media_busy}
                              variant="contained"
                              sx={{
                                background: theme.palette.error.dark,
                                '&:hover': {
                                  background: theme.palette.error.main,
                                },
                              }}
                              onClick={() => {}}
                            >
                              {TitleService('Delete Media')}
                            </Button>
                          }
                          cancelText={TitleService('No')}
                          affirmativeText={TitleService('Yes')}
                          title={TitleService('Are you sure?')}
                          onOk={async () => {
                            if (getSelectedItem().id) {
                              setDeleteArgs(getSelectedItem().id)
                            }
                          }}
                          description={TitleService(
                            'This will soft delete the media item.',
                          )}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      {isApprovalRequestRejected() && SC.errorSign()}
                    </Grid>
                    <Grid item>
                      <Typography variant="h4" sx={{ m: 0 }}>
                        {isApprovalRequestRejected() &&
                          TitleService('Rejected')}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="h5" sx={{ m: 0 }}>
                        {isApprovalRequestRejected() &&
                          TitleService(
                            getApprovalRequestItem()?.rejectionReason,
                          )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardActions>
            <Divider />
          </>
        )}
        {(mediaDescriptionValid || mediaDescriptionValid === null) &&
          !isUploading &&
          (mediaDescriptionDirty ||
            thumbnailsDirty ||
            uploaded ||
            tagsDirty) && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="flex-end">
                <AnimateButton>
                  <Button
                    variant="contained"
                    disabled={
                      !(
                        (mediaDescriptionValid ||
                          mediaDescriptionValid === null) &&
                        !isUploading &&
                        (mediaDescriptionDirty ||
                          thumbnailsDirty ||
                          uploaded ||
                          tagsDirty)
                      )
                    }
                    onClick={async () => {
                      setUploaded(false)
                      await dispatch(updateMediaToContentHouse)

                      clearForm(selectedMedia)
                    }}
                  >
                    {TitleService('Verify & Submit')}
                  </Button>
                </AnimateButton>
              </Stack>
            </Grid>
          )}
        {mode === 'view-media' && selectedMediaItem && (
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12} sm={12} md={12}>
              <MediaDescriptionForm
                page={undefined}
                form={mediaDescription}
                onUpdate={(update, valid, dirty) => {
                  setMediaDescription(update)
                  setMediaDescriptionValid(valid)
                  setMediaDescriptionDirty(dirty)
                }}
                context={{
                  mediaRel: mediaContext,
                  id: contextId,
                }}
              />
              <RedQuickInputTags
                value={tags || []}
                onUpdate={(data) => {
                  setTags(data)
                  setTagsDirty(true)
                }}
              />
              <TagAdditionComponent
                onSelect={(val: string) => {
                  if (tags.indexOf(val) === -1) {
                    setTags([...tags, val])
                    setTagsDirty(true)
                  }
                }}
              />
              <MediaForm
                page={undefined}
                form={selectedMediaItem}
                context={{
                  mediaRel: {
                    ...mediaContext,
                    onDuration: (duration: number) => {
                      setNewMedia({
                        mediaDuration: duration,
                      })
                    },
                  },
                  mediaPreviewUrl: {
                    title: 'Preview Media',
                    componentTitle: 'Preview Media',
                    accept: 'video/mp4,video/x-m4v,video/*',
                    uploadOnce: false,
                    limit: 1,
                    description: 'Upload your media intro clip.',
                    contextId: contextId,
                    storageLocation: `media/${params?.id}/previewMedia`,
                    video: true,
                    onDuration: (duration: number) => {
                      setMediaPreviewDuration(duration)
                    },
                    onStorageLocation: (location: string) => {
                      setMediaPreviewLocation(location)
                      setUploaded(true)
                    },
                  },
                  thumbnail: {
                    image: true,
                    title: 'Media Thumbnail',
                    componentTitle: 'Media Thumbnail',
                    contextId: contextId,
                    aspectRatio: 16 / 9,
                    limit: 1,
                    storageLocation: `media/${params?.id}/thumbnails`,
                    description: 'Upload thumbnail title image for media',
                    maxSize: 4000,
                    onStorageLocation: (location: string) => {
                      setThumbnailLocation(location)
                      setUploaded(true)
                    },
                  },
                  transparentTitleUrl: {
                    image: true,
                    title: 'Media Transparent Title Image',
                    componentTitle: 'Media Transparent Title Image',
                    contextId: contextId,
                    aspectRatio: 16 / 9,
                    storageLocation: `media/${params?.id}/transparentTitleImage`,
                    limit: 1,
                    description: 'Upload cover title image for media',
                    maxSize: 4000,
                    onStorageLocation: (location: string) => {
                      setTransparentTitleLocation(location)
                      setUploaded(true)
                    },
                  },
                  id: contextId,
                }}
                onUpdate={(update) => {
                  setSelectedMediaItem({ ...selectedMediaItem, ...update })
                  setUploaded(true)
                }}
              />
            </Grid>

            {(mediaDescriptionValid || mediaDescriptionValid === null) &&
              !isUploading &&
              (mediaDescriptionDirty ||
                thumbnailsDirty ||
                uploaded ||
                tagsDirty) && (
                <Grid item xs={12}>
                  <Stack direction="row" justifyContent="flex-end">
                    <AnimateButton>
                      <Button
                        variant="contained"
                        disabled={
                          !(
                            (mediaDescriptionValid ||
                              mediaDescriptionValid === null) &&
                            !isUploading &&
                            (mediaDescriptionDirty ||
                              thumbnailsDirty ||
                              uploaded ||
                              tagsDirty)
                          )
                        }
                        onClick={async () => {
                          setUploaded(false)
                          await dispatch(updateMediaToContentHouse)

                          clearForm(selectedMedia)
                        }}
                      >
                        {TitleService('Verify & Submit')}
                      </Button>
                    </AnimateButton>
                  </Stack>
                </Grid>
              )}
          </Grid>
        )}
      </>
    )
  }

  let output_updateMediaForms = updateMediaForms(
    autoThunks.updateMediaContentToContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      media: (() => {
        function _getNewMedia(): any {
          let updates: any = {}
          if (mediaDuration) {
            updates.mediaDuration = mediaDuration
          }
          if (mediaPreviewDuration) {
            updates.mediaPreviewDuration = mediaPreviewDuration
          }
          if (mediaLocation) {
            updates.mediaRelLocation = mediaLocation
          }
          if (mediaPreviewLocation) {
            updates.mediaPreviewLocation = mediaPreviewLocation
          }
          if (thumbnailLocation) {
            updates.thumbnailLocation = thumbnailLocation
          }
          if (transparentTitleLocation) {
            updates.transparentTitleLocation = transparentTitleLocation
          }
          return {
            ...(selectedMediaItem || {}),
            ...updates,
          }
        }
        return _getNewMedia()
      })(),
      tags: (() => {
        function _getNewMedia(): any {
          return tags
        }
        return _getNewMedia()
      })(),
      mediaDescription: (() => {
        function _getMediaDescription(): any {
          return mediaDescription
        }
        return _getMediaDescription()
      })(),
      thumbNails: (() => {
        function _getThumbnails(): any {
          return thumbnails
        }
        return _getThumbnails()
      })(),
    }),
    autoThunks.requestMediaContentApprovalForContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      mediaId: (() => {
        function _getNewMedia(): any {
          return selectedMediaItem?.id
        }
        return _getNewMedia()
      })(),
    }),
    autoThunks.cancelMediaContentApprovalForContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      mediaId: (() => {
        function _getNewMedia(): any {
          return selectedMediaItem?.id
        }
        return _getNewMedia()
      })(),
    }),
  )

  function main_card(
    contentHouseMediaList: any,
    addNewMedia: any,
    viewMedia: any,
  ): any {
    return (() => {
      let item = (localMedias || []).find((v) => v.id === selectedMedia)
      return (
        <Grid container spacing={gridSpacing}>
          <Busy />
          <Grid item xs={12} sm={6} md={4}>
            <SubCard
              title={TitleService('Media')}
              secondary={
                <SecondaryAction
                  icon={
                    <AddIcon
                      onClick={() => {
                        setMode('add-new-media')
                        setTags([])
                        setNewMediaTags([])
                        setThumbnails([])
                        clearForm()
                      }}
                    />
                  }
                />
              }
            >
              {contentHouseMediaList}
            </SubCard>
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <SubCard
              title={
                mode !== 'add-new-media'
                  ? item?.description?.nameDefault || item?.name
                  : TitleService('Add New Media')
              }
            >
              {addNewMedia}
              {viewMedia}
            </SubCard>
          </Grid>
        </Grid>
      )
    })()
  }

  let output_main_card = main_card(
    output_mediaList,
    output_addNewMediaForms,
    output_updateMediaForms,
  )

  return output_main_card
}
